import request from '@/utils/request'

// 购物车列表
export function cartList(params) {
  return request({
    url:'/Crm.Pdcart/cartList',
    method:'get',
    params:params
  })
}

// 删除购物车产品
export function cartDelete(data) {
  return request({
    url:'/Crm.Pdcart/cartDelete',
    method:'post',
    data:data
  })
}

// 购物车产品新建报价单
export function cartAddToQuote(data) {
  return request({
    url:'/Crm.Pdcart/cartAddToQuote',
    method:'post',
    data:data
  })
}

// 购物车产品添加到已有报价单
export function addToExistingQuotation(data) {
  return request({
    url:'/Crm.Pdcart/addToExistingQuotation',
    method:'post',
    data:data
  })
}

// 购物车产品新建订单
export function cartAddToOrders(data) {
  return request({
    url:'/Crm.Pdcart/cartAddToOrders',
    method:'post',
    data:data
  })
}

// 购物车产品添加到已有订单
export function addToExistingOrders(data) {
  return request({
    url:'/Crm.Orders/addToExistingOrder',
    method:'post',
    data:data
  })
}

// 购物车产品新建退货订单
export function cartAddToReturnGoodsOrders(data) {
  return request({
    url:'/Crm.Pdcart/cartAddToReturnGoodsOrders',
    method:'post',
    data:data
  })
}

// 购物车产品新建无实物退货订单
export function cartAddToNoMaterialObjectReturnOrder(data) {
  return request({
    url:'/Crm.Pdcart/cartAddToNoMaterialObjectReturnOrder',
    method:'post',
    data:data
  })
}

// 购物车产品添加到已有无实物退货订单
export function addToNoMaterialObjectReturnOrder(data) {
  return request({
    url:'/Crm.Pdcart/addToNoMaterialObjectReturnOrder',
    method:'post',
    data:data
  })
}

// 购物车产品新建礼品单
export function cartAddToGift(data) {
  return request({
    url:'/Crm.Pdcart/cartAddToGift',
    method:'post',
    data:data
  })
}

// 购物车产品添加到已有礼品订单
export function addToGift(data) {
  return request({
    url:'/Crm.Pdcart/addToGift',
    method:'post',
    data:data
  })
}

// 购物车数量修改
export function cartQtyUpdate(data) {
  return request({
    url:'/Crm.Pdcart/cartQtyUpdate',
    method:'post',
    data:data
  })
}

// 购物车产品导出EXCEL
export function cartProductExportExcel(params) {
  return request({
    url:'/Crm.Pdcart/cartProductExportExcel',
    method:'get',
    params:params,
    responseType: "blob"
  });
}



// WEBPACK FOOTER //
// ./src/api/cart.js